import { forwardRef, ForwardRefRenderFunction, HTMLAttributes } from 'react';
import { Slot } from '@radix-ui/react-slot';

export type InputFieldLabelProps = Omit<
  HTMLAttributes<HTMLLabelElement>,
  'className'
> & {
  asChild?: boolean;
};

const InputFieldLabelRenderFunction: ForwardRefRenderFunction<
  HTMLLabelElement,
  InputFieldLabelProps
> = ({ asChild, ...attrs }, ref) => {
  let Element = asChild ? Slot : 'label';

  return (
    <Element
      {...attrs}
      ref={ref}
      className="label-md text-marine-high-emphasis"
    />
  );
};

export const InputFieldLabel = forwardRef<
  HTMLLabelElement,
  InputFieldLabelProps
>(InputFieldLabelRenderFunction);
